import { Component, ElementRef, ViewChild } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AuthenticationService } from '../../_services/authentication.service';
import { DatasearchService } from '../../_services/datasearch.service';
import { GlobalService } from '../../_services/global.service';
import { getCountries, getCountryCallingCode } from 'libphonenumber-js'; // @ts-ignore
import { NgClass, NgFor, NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { RecaptchaModule } from 'ng-recaptcha';

declare var bootstrap: any;
declare var $: any;
@Component({
  selector: 'app-demo-request',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    NgIf,
    NgFor,
    RecaptchaModule,
  ],
  templateUrl: './demo-request.component.html',
  styleUrl: './demo-request.component.scss',
})
export class DemoRequestComponent {
  @ViewChild('alertModal', { static: false }) alertModal!: ElementRef;
  alertVisible: boolean = false;
  countries: any[] = [];
  originalCountries: any[] = [];
  demorequestForm: FormGroup = this.fb.group({});
  selectedCountdemo: number = 0;
  recaptchaResponse: string | null = null;
  formSubmitted = false;
  recaptchaSiteKey = '6LfvdWgqAAAAAB4irdmbPCmlpmyBzGLjGVIrHE_S'; // live
  // recaptchaSiteKey = '6Lcpo3QqAAAAAIKDJyb4lg4QKCWMuQMA7VxbP9uD'; // local
  recaptchaToken: string | null = null;
  verticals: { vertical: string; checked: boolean }[] = [
    { vertical: 'AgroPat Ultimate Discovery Suite', checked: false },
    { vertical: 'AgroPat Ultimate Discovery Suite - Classic', checked: false },
    { vertical: 'AgroPat Ultimate Generic Suite', checked: false },
    { vertical: 'Technical Routes - Essential Chemical Manufacturing Guide', checked: false },
    { vertical: 'ChemiTracker - A Supplier Guide', checked: false },
    { vertical: 'Global MRL Database', checked: false },
    { vertical: 'QuikPatent - Agrochemical Constraining Patent Guide', checked: false },
    { vertical: 'Indian Pesticide Database (IPD)', checked: false },
    { vertical: 'Global Agro Product Directory (GAPD)', checked: false },
    { vertical: 'PharmVetPat Ultimate', checked: false },
    { vertical: 'PharmVetPat Ultimate - API Generic Suite', checked: false },
    { vertical: 'SPC Database - Europe Generic Constraining Date Guide', checked: false },
    { vertical: 'Indian Medicine Database (IMD)', checked: false },
    { vertical: 'AgroPharm XIM 1.0 DB', checked: false },
    { vertical: 'AgroPharm XIM 2.0 DB', checked: false },
    { vertical: 'ActivePatents - Pharmaceutical API Constraining Patent Guide', checked: false },
    { vertical: 'BuyChem - Chemical Buy-Sale Platform', checked: false },
    { vertical: 'ChemRobotics® Jobs', checked: false },
    { vertical: 'Global Business Events - Trade Shows, Exhibitions, & Conferences Beta', checked: false },
    { vertical: 'Knō Ure KompeteR - Global Innovation Watch', checked: false },
    { vertical: 'Company Directory', checked: false }
  ];
  constructor(
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private datasearch: DatasearchService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadCountryCodes();
    this.initialiseForm();
    // this.globalService.getOpenDemoModel().subscribe((open: boolean) => {
    //   if (open) {
    //     $('#demo-form').modal('show'); // Assuming jQuery is being used for modal
    //   }
    // });
    this.updateSelectedCount();
  }

  initialiseForm() {
    this.demorequestForm = this.fb.group({
      verticals: [''], // No validators for this, set dynamically
      date: ['', Validators.required],
      time: ['', Validators.required],
      fname: ['', Validators.required],
      lname: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      country_code: ['+91', Validators.required],
      phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      job: ['', Validators.required],
      company: ['', Validators.required],
      country: ['', Validators.required],
      industry: ['', Validators.required],
      comment: [''],
      web: ['Agro'],
      source: [''],
      // Remove recaptcha from the form
    });
  }

  loadCountryCodes() {
    const uniqueCountries = new Map();
    getCountries().forEach((country) => {
      const code = `+${getCountryCallingCode(country)}`;
      const flag = `https://flagcdn.com/16x12/${country.toLowerCase()}.png`;
      if (!uniqueCountries.has(code)) {
        uniqueCountries.set(code, { code, flag });
      }
    });
    this.countries = Array.from(uniqueCountries.values());
  }
  toggleVerticalChecked(index: number) {
    this.verticals[index].checked = !this.verticals[index].checked;
    this.updateSelectedCount();
    this.updateVerticalsFormControl();
  }
  updateSelectedCount() {
    this.selectedCountdemo = this.verticals.filter((v) => v.checked).length;
  }
  updateVerticalsFormControl() {
    const selectedVerticals = this.verticals
      .filter((v) => v.checked)
      .map((v) => v.vertical)
      .join(', ');
    this.demorequestForm.controls['verticals'].setValue(selectedVerticals);
  }

  submit_demo_form() {
    this.formSubmitted = true;

    if (this.demorequestForm.invalid || !this.recaptchaResponse) {
      this.demorequestForm.markAllAsTouched();
      return;
    }

    // Capture selected verticals
    const verticalArr = this.verticals
      .filter((v) => v.checked)
      .map((v) => v.vertical)
      .join();
    this.demorequestForm.controls['verticals'].setValue(verticalArr);

    // Capture checked sources
    const sourceArr = Array.from(
      document.querySelectorAll('input[name="source"]:checked')
    )
      .map((el: any) => el.value)
      .join();
    this.demorequestForm.controls['source'].setValue(sourceArr);

    // Append ':00' to the time value
    this.demorequestForm.value.time += ':00';

    // Prepare email data
    const emailPostData = {
      to: 'support@chemrobotics.com',
      cc: 'greenbookcorp@gmail.com',
      subject: 'Demo Request (Agro)',
      html: `
        <div style="background-color: #ffc702; height:30px; text-align: center;">
          <img src="cid:logoImg" alt="Logo">
        </div>
        <div style="background-color: #eee;">
          <p>New demo request received now!</p>
        </div> 
        <div style="background-color: #eee;">
          <p>Name: <strong>${this.demorequestForm.value.fname} ${this.demorequestForm.value.lname}</strong></p>
        </div>
        <div style="background-color: #eee;">
          <p>Email: <strong>${this.demorequestForm.value.email}</strong></p>
        </div>
        <div style="background-color: #eee;">
          <p>Phone: <strong>${this.demorequestForm.value.phone}</strong></p>
        </div>
        <div style="background-color: #eee;">
          <p>Job: <strong>${this.demorequestForm.value.job}</strong></p>
        </div>
        <div style="background-color: #eee;">
          <p>Company: <strong>${this.demorequestForm.value.company}</strong></p>
        </div>
        <div style="background-color: #eee;">
          <p>Country: <strong>${this.demorequestForm.value.country}</strong></p>
        </div>
        <div style="background-color: #eee;">
          <p>Industry: <strong>${this.demorequestForm.value.industry}</strong></p>
        </div>
        <div style="background-color: #eee;">
          <p>Demo Date: <strong>${this.demorequestForm.value.date}</strong></p>
        </div>
        <div style="background-color: #eee;">
          <p>Demo Time: <strong>${this.demorequestForm.value.time}</strong></p>
        </div>
        <div style="background-color: #eee;">
          <p>Vertical/Platform: <strong>${this.demorequestForm.value.verticals}</strong></p>
        </div>
        <div style="background-color: #eee;">
          <p>Comment: <strong>${this.demorequestForm.value.comment}</strong></p>
        </div>
        <hr>
        <div style="background-color: #eee; text-align: center;">
          <p>Copyright 2023 <strong><a href="https://www.chemrobotics.com/">ChemRobotics®</a></strong></p>
        </div>
      `,
    };

    const postdata = {
      demoRequest: this.demorequestForm.value,
      emailPostData: emailPostData,
    };

    this.datasearch.sendDemorequest(postdata).subscribe(
      (response) => {
        this.formSubmitted = false;
        this.openmodelalert();
        setTimeout(() => {
          this.router.navigate(['/home']); // Redirect to home page
        }, 5000); // Wait for the alert to be shown
        this.demorequestForm.reset();
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }
  openmodelalert() {
    const alertModalEl = this.alertModal.nativeElement;
    const bsAlertModal = new bootstrap.Modal(alertModalEl);
    bsAlertModal.show();
    setTimeout(() => {
      bsAlertModal.hide();
    }, 5000);
  }
  onCaptchaSuccess(token: string | null) {
    // console.log('reCAPTCHA resolved with token:', token);
    this.recaptchaToken = token;
  }

  closeAlert() {
    this.alertVisible = false;
  }
}
